import React from 'react'

// Inline: `code`, **bold**, *italic* (bold matched before italic). Skips ☐ lines.
function inline (text, keyBase) {
  const nodes = []
  const re = /(`[^`]+`|\*\*[^*]+\*\*|\*[^*\n]+\*)/g
  let last = 0, m, k = 0
  while ((m = re.exec(text))) {
    if (m.index > last) nodes.push(text.slice(last, m.index))
    const t = m[0]
    const key = `${keyBase}-${k++}`
    if (t.startsWith('`')) nodes.push(<code key={key} className="study-ic">{t.slice(1, -1)}</code>)
    else if (t.startsWith('**')) nodes.push(<strong key={key}>{t.slice(2, -2)}</strong>)
    else nodes.push(<em key={key}>{t.slice(1, -1)}</em>)
    last = m.index + t.length
  }
  if (last < text.length) nodes.push(text.slice(last))
  return nodes
}

// Structured renderer: lead headings (all-bold lines), numbered lists with badges,
// bullets, paragraphs. Used for instruction screens and survey intros.
export default function RichText ({ text }) {
  const lines = (text || '').split('\n')
  const out = []
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    if (line.trim().startsWith('☐')) continue
    if (line.trim() === '') { out.push(<div key={i} className="study-rich__gap" />); continue }

    const lead = line.trim().match(/^\*\*(.+)\*\*$/)
    if (lead) { out.push(<h3 key={i} className="study-rich__lead">{inline(lead[1], i)}</h3>); continue }

    const num = line.match(/^\s*(\d+)\.\s+(.*)$/)
    if (num) {
      out.push(
        <div key={i} className="study-rich__num">
          <span className="study-rich__badge">{num[1]}</span>
          <span>{inline(num[2], i)}</span>
        </div>
      )
      continue
    }

    const bul = line.match(/^\s*[-*]\s+(.*)$/)
    if (bul) { out.push(<div key={i} className="study-rich__li">{inline(bul[1], i)}</div>); continue }

    out.push(<p key={i}>{inline(line, i)}</p>)
  }
  return <div className="study-rich">{out}</div>
}
